/**
 * The screens that differ between the TRUS-762 member profile and the previous
 * one, each picking its version by the org's `member_profile_v2` capability
 * (see memberProfileRollout). Hosts import these instead of either version.
 */
import MemberProfileNew from '@/components/members/MemberProfileNew';
import MemberProfileLegacy from '@/components/members/MemberProfileLegacy';
import { EnrollmentDetailNew } from '@/components/enrollments/EnrollmentDetailNew';
import { EnrollmentDetailNew as EnrollmentDetailLegacy } from '@/components/enrollments/EnrollmentDetailLegacy';
import { FormLibraryNew } from '@/components/forms/FormLibraryNew';
import { FormLibraryNew as FormLibraryLegacy } from '@/components/forms/FormLibraryLegacy';
import { withMemberProfileV2 } from './memberProfileRollout';

export const MemberProfile = withMemberProfileV2<any>(MemberProfileNew, MemberProfileLegacy, 'MemberProfile');
export const EnrollmentDetail = withMemberProfileV2<any>(EnrollmentDetailNew, EnrollmentDetailLegacy, 'EnrollmentDetail');
export const FormLibrary = withMemberProfileV2<any>(FormLibraryNew, FormLibraryLegacy, 'FormLibrary');
